document.addEventListener('DOMContentLoaded', function () {

  const addAllButton = document.getElementById('preview-add-all');
  const previewArea = document.getElementById('preview-area');

  if (!addAllButton || !previewArea) return;

  addAllButton.addEventListener('click', async () => {
    const productCards = previewArea.querySelectorAll('.preview-item');

    if (productCards.length === 0) return;

    try {
      // Persistentes Array aus localStorage
      let previeItems = JSON.parse(localStorage.getItem('previewProducts')) || [];
      formData = { 'items': previeItems };

      console.log( 'formData: ' + JSON.stringify(formData))

      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        console.log( "Posting to cart returned: " + JSON.stringify(response.json()));
        window.location.href = '/cart';
      })
      .catch((error) => {
        console.error('Error adding products to cart:', error);
      });
    }
    catch(error) {
      console.error('Error adding products to cart:', error);
    }
  });
});
